export default "__VITE_ASSET__BGIVk_0L__"